import React from 'react';
import { Helmet } from 'react-helmet';
import { ISignUpOTPProps } from '../../types/propTypes';
import { Formik, Field } from 'formik';
import { Form, Button } from 'react-bootstrap';
import { ReactstrapInput } from '../../components/reactstrap-formik';
import { SignUpOTPSchema } from '../../validation/login/login-validation';
import { ISignUpOTPFormField } from '../../models/login';
import { Common } from '../../utils/constants';
import { signupConfirm, resendOtp } from '../../services/login/login-service';
import { toast } from 'react-toastify';
import images from '../../assets/images';
import { companyNameReplace } from '../../utils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { formatMessageWithBoldTitle, maskEmail } from '../../utils/helper';
import { useCountdownTimer } from '../../utils/useCountdownTimer';
import OTPField from '../../components/common/OTPField';

const SignUpOTPForm = (props: ISignUpOTPProps) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const initialState: ISignUpOTPFormField = {
    code: '',
  };

  const { secondsLeft, start, formattedTime, isRunning } = useCountdownTimer({
    initialSeconds: 45,
    autoStart: true,
  });

  const handleSubmit = async (value: ISignUpOTPFormField) => {
    value.username = props.email.toLowerCase();

    return signupConfirm(value)
      .then(async (res) => {
        if (res.isSignUpComplete === true) {
          navigate('/login');
          toast.success(formatMessageWithBoldTitle(t('signup.toast.postSignupLoginMessage')));
        }
      })
      .catch((err) => {
        if (err && err.name === Common.Authentication.CodeMismatchException) {
          toast.error(t('signup.toast.invalidCode'));
        } else {
          toast.error(t('signup.toast.error'));
        }
      })
      .finally();
  };

  const resendOtpSubmit = async () => {
    await resendOtp(props.email)
      .then(() => {
        toast.success(t('signup.toast.resendSignupCode'));
        start();
      })
      .catch((error) => {
        if (error && error.name === 'LimitExceededException') {
          toast.error(t('signup.toast.resendLimitExceeded'));
        } else {
          toast.error(t('signup.toast.error'));
        }
      });
  };

  return (
    <>
      <Helmet>
        <title>{companyNameReplace(t('signup.title'))} </title>
      </Helmet>
      <button
        type="button"
        className="btn btn-icon btn-link pr-0 btn-back"
        onClick={() => props.onChangeStage(Common.AuthStage.SIGNIN)}
        title={t<string>('signup.button.back')}
      >
        <img className="icon" src={images.backArrowRSVG} alt={t<string>('signup.button.back')} />
      </button>
      <div className="title-outer">
        <h1 className="title">
          <span className="icon">
            <img src={images.emailSVG} alt={t<string>('navbar.title')} />
          </span>
          {t('signup.label.signUpOTPConfirmationTitle')}
        </h1>

        <p className="confirm-signUp">{t('signup.label.signUpOTPConfirmationMessage')}</p>
      </div>
      <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={SignUpOTPSchema(t)}>
        {(props) => {
          const { handleSubmit } = props;
          return (
            <form className="form-secondary" onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="">
                <OTPField name="code" />
              </div>
              <Form.Group className="form-group">
                <Button type="submit" className="btn btn-primary w-100">
                  {t('signup.button.confirm')}
                </Button>
              </Form.Group>

              {isRunning && secondsLeft > 0 ? (
                <div className="clearfix pt-1">
                  <p className="sign-up-otp pb-0">{t('signup.label.otpSentMessage')}</p>
                  <p className="sign-up-otp">
                    <span>
                      {t('signup.label.resendMessage')} {formattedTime}
                    </span>
                  </p>
                </div>
              ) : (
                <div className="clearfix pt-1">
                  <p className="sign-up-otp pb-0">{t('signup.label.resendTitle')} </p>
                  <p className="sign-up-otp">
                    <a href="#" title={t<string>('signup.button.resend')} onClick={resendOtpSubmit}>
                      {t('signup.button.resend')}
                    </a>
                  </p>
                </div>
              )}
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default SignUpOTPForm;
